import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(!localStorage.getItem("struktiv_cookie_notice"));
  }, []);
  if (!show) return null;
  const accept = () => {
    localStorage.setItem("struktiv_cookie_notice", new Date().toISOString());
    setShow(false);
  };
  return (
    <div className="fixed inset-x-4 bottom-4 z-[60] mx-auto max-w-2xl rounded-2xl border border-[#EDE3D9] bg-[#FFFDFB] p-5 shadow-xl sm:flex sm:items-center sm:gap-5" data-testid="cookie-banner">
      <p className="text-sm text-[#242020]/85">
        Ce site utilise uniquement le stockage essentiel à son fonctionnement (conservation de vos réponses pendant la session). Aucun témoin publicitaire ni outil de suivi n'est actif.{" "}
        <Link to="/politique-de-confidentialite" className="text-[#650D23] underline">En savoir plus</Link>
      </p>
      <button onClick={accept} className="btn-primary mt-4 shrink-0 !px-5 !py-2.5 text-sm sm:mt-0" data-testid="cookie-accept-button">J'ai compris</button>
    </div>
  );
};
